import { Scale } from "lucide-react";

import { UpcomingLawsMonitorPanel } from "@/components/legislation_monitor/UpcomingLawsMonitorPanel";
import { MunicipalitySwitcher } from "@/components/launch_pad/MunicipalitySwitcher";
import { ModuleWorkspaceBody } from "@/components/module_summary/ModuleWorkspaceBody";
import { ModuleWorkspaceHeader } from "@/components/module_summary/ModuleWorkspaceHeader";
import {
  MODULE_WORKSPACE_X,
  MODULE_WORKSPACE_Y,
  moduleWorkspaceNarrowContentClass,
  moduleWorkspaceShellClass,
} from "@/components/module_summary/moduleWorkspaceLayout";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useLegislationMonitorSelection } from "@/hooks/legislationMonitor/useLegislationMonitorSelection";
import { legislationMonitorSubtitle } from "@/lib/legislationMonitorFormat";
import { cn } from "@/lib/utils";

export function LegislationMonitorWorkspace() {
  const selection = useLegislationMonitorSelection();
  const subtitle = selection.municipality
    ? legislationMonitorSubtitle(selection.municipality.name || "your municipality", selection.selectedState)
    : "Select a municipality to view upcoming laws";

  return (
    <div className={cn(moduleWorkspaceShellClass, "flex-1 min-h-0")} data-testid="legislation-monitor-workspace">
      <ModuleWorkspaceHeader
        title="Legislation Monitor"
        subtitle={subtitle}
        leading={
          <div className="rounded-lg bg-primary/10 p-2">
            <Scale className="h-6 w-6 text-primary" aria-hidden />
          </div>
        }
        actions={<MunicipalitySwitcher />}
        data-testid="legislation-monitor-header"
      />

      <ModuleWorkspaceBody
        width="none"
        className="flex min-h-0 flex-1 flex-col overflow-hidden !p-0"
        contentClassName="flex h-full min-h-0 flex-1 flex-col"
      >
        <ScrollArea className="h-full min-h-0 flex-1">
          <div className={cn(moduleWorkspaceNarrowContentClass, MODULE_WORKSPACE_X, MODULE_WORKSPACE_Y)}>
            <UpcomingLawsMonitorPanel {...selection} />
          </div>
        </ScrollArea>
      </ModuleWorkspaceBody>
    </div>
  );
}
